<template>
  <div class="tabs">
    <div class="title">
      <img v-if="showBackIcon" src="@/assets/image/图标-20.png"  class="navBarImg" alt="" @click="back" />
      <div class="examHelp">考试帮助</div>
    </div>
    <nut-tabs class="tabClick" v-model="tabValue" size="small" title-scroll title-gutter="10">
      <nut-tabpane v-for="(item) in taskTypeList" :key="item" :title="taskListToTaskName(item)"> 
        <iframe class="iframe_css" :src="taskListRelateUrl(item)"></iframe>
      </nut-tabpane>
    </nut-tabs>
  </div>
</template>
<script>
import { computed, defineComponent, onBeforeMount, reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import { taskTypeListMap, examTypeUrl } from './config'
export default defineComponent({
  setup() {
    const router = useRouter()
    const store = useStore()
    const data = reactive({
      tabValue: '0',
      taskTypeList: [],
      showBackIcon: true,
    });
    const route = useRoute()
    onBeforeMount(() => {
      if(route.query.taskTypeList){
        data.taskTypeList = JSON.parse(route.query.taskTypeList)
      }
      data.showBackIcon = !store.state.isH5;
    })
    const back = () => {
      router.push({
        path:'/examination',
        query: {
          examId: sessionStorage.getItem('examId'),
          previewBtn: store.state.previewBtn
          // isHelpBack: true
        }
      })
    }
    // taskTypeList转换为对应的文字
    const taskListToTaskName = computed(() => {
      // let arr = []
      // data.taskTypeList && data.taskTypeList.map((item) => {
      //   arr.push({
      //     title: taskTypeListMap.get(Number(item)),
      //     index: item
      //   })
      // })
      // return arr
      return (item) => {
        return taskTypeListMap.get(Number(item))
      }
    })
    // taskTypeList转换为对应url
    const taskListRelateUrl = computed(() => {
      return (item) => {
        return examTypeUrl.get(Number(item))
      }
    })
    return {
      ...toRefs(data),
      taskListToTaskName,
      taskListRelateUrl,
      back,
      store,
      router
    };
  },
});
</script>
<style scoped lang='scss'>
.tabs {
  & .title{
    position: relative;
    margin-top: 22px;
  }
  & .examHelp{
    font-size: 16Px;
    line-height: 20px;
    font-weight: Bold;
    text-align: center;
  }
  & :deep(.nut-tabs .nut-tabs__content) {
    display: flex ;
    height: 100vh;
  }

  // & :deep(.nut-tabs__titles){
  //   margin-left: 20Px;
  // }
  & :deep(.nut-tabs__titles-item__text){
    opacity: 0.8;
    font-size: 14Px;
    margin-bottom: 9px;
  }
  & :deep(.nut-tabs__titles-item){
    font-size: 14Px;
    font-weight: 500;
    line-height: 16Px;
  }
  & :deep(.nut-tabs__titles-item.active .nut-tabs__titles-item__line){
    width: 30px;
    height: 3px;
    border-radius: 1.5px;
    background: #0087FF;
  }
}
.tabClick{
  & :deep(.nut-tabpane){
    padding: 0;
  }
}
.tabDiv{
  margin-left: 10Px;
}
.navBarImg{
  position: absolute;
  left: 9Px;
  width: 20px;
  height: 20px;
  line-height: 20px;
}

.iframe_css{
  height: 100%;
  width: 100%;
}
</style>